<template>
  <div class="add-widget">
    <navi-modal
      :animation="screen.breakPoint.tabLand ? 'slide-down' : 'slide-up'"
      handle-click-bg
      v-model="show"
      :min-width="width"
      :full="!screen.breakPoint.tabLand"
      :showSettingsMobile.sync="showSettingsMobile"
      :title="$t('widgets.Dashboard.AddWidget.addWidget')"
    >
      <template v-slot:activator="{ on }">
<!--        <button class="add-widget__btn" @click="on">-->
<!--          <span class="add-widget__icon icon-plus"></span>-->
<!--          <span class="add-widget__text"></span>-->
<!--        </button>-->
        <v-button @click="on" color="success"><span class="d-flex align-center"><span class="mr-1 text--bold icon-plus d-block"></span><span class="d-block">{{ $t('widgets.Dashboard.AddWidget.addWidget') }}</span></span></v-button>
      </template>

      <template v-slot:header>
        {{computedActiveTab.name}}
      </template>

      <template v-slot:navigation>
        <navi-modal-item
          v-for="(item, index) of computedAvailableWidgets"
          :key="index"
          @click="setActiveTab(computedAvailableWidgets[index].key)"
          :active="menuItemClass(computedAvailableWidgets[index].key, index)"
        >
          {{item.name}}
        </navi-modal-item>
      </template>
        <div class="add-widget__modal-title heading-4 mb-2" v-if="screen.breakPoint.tabPort">
          {{computedActiveTab.name}}
        </div>
        <div class="add-widget__modal-description text-color-grey mb-2">
          {{computedActiveTab.description}}
        </div>
        <div class="add-widget__opts">
          <div class="add-widget__opts-left" v-if="computedActiveTab.settings">
            <div class="text--xs-small text--uppercase text--medium text-color-grey-darken mb-2">{{ $t('widgets.Dashboard.AddWidget.settings') }}</div>
            <div class="mb-1" v-for="(setting, index) of computedActiveTab.settings" :key="'setting' + index">
              <component :is="setting.component" v-bind="{ ...setting.props, value: settings[computedActiveTab.key] ? settings[computedActiveTab.key][setting.settingsKey] : null }" v-on="{ input: (e) => handleEvent(e, computedActiveTab.key, setting.settingsKey) }"></component>
            </div>
          </div>
          <div class="add-widget__opts-right">
            <div class="text--xs-small text--uppercase text--medium text-color-grey-darken mb-2">{{ $t('widgets.Dashboard.AddWidget.preview') }}</div>
            <div class="add-widget__preview">
              <component :is="computedActiveTab.component" v-bind="{ ...settings[computedActiveTab.key] }"></component>
            </div>
          </div>
        </div>

      <template v-slot:footer>
        <div class="d-flex justify-end">
          <v-button @click="add">{{ $t('widgets.Dashboard.AddWidget.add') }}</v-button>
        </div>
      </template>
    </navi-modal>
  </div>
</template>

<script>
import NaviModal from '@/ui/modals/NaviModal'
import NaviModalItem from '@/ui/modals/NaviModalItem'
import vButton from '@/ui/controls/vButton'

import screen from '@/mixins/screen'
import { dashboardWidgets, addWidget } from '@/mixins/dashboardMixin'

export default {
  mixins: [screen, dashboardWidgets, addWidget],

  components: {
    NaviModal,
    NaviModalItem,
    vButton
  },

  data () {
    return {
      show: false,
      showSettingsMobile: false,
      activeTab: null,
      settings: {}
    }
  },

  computed: {
    computedAvailableWidgets () {
      return this.availableWidgets.filter(item => {
        return !item.hide
      })
    },

    computedActiveTab () {
      const activeTab = this.activeTab ? this.activeTab : this.computedAvailableWidgets[0].key
      return this.computedRegisteredWidgets[activeTab]
    },

    activeTabComponent () {
      return {
        component: this.activeTab ? this.activeTab : this.computedAvailableWidgets[0].key,
        props: this.settings[this.computedActiveTab.key]
      }
    },

    width () {
      let out = '75rem'

      if (this.screen.breakPoint.bigDesktop) {
        out = '75rem'
      }

      return out
    }
  },

  beforeMount () {
    this.settings = this.availableSettingsRow
  },

  methods: {
    add () {
      this.addWidget(this.activeTabComponent.component, this.activeTabComponent.props)
      this.show = false
    },

    setActiveTab (key) {
      this.activeTab = key
      this.showSettingsMobile = true
    },

    menuItemClass (key, index) {
      return this.activeTab === key || (!this.activeTab && index === 0)
    },

    handleEvent (e, key, settingsKey) {
      this.settings[key][settingsKey] = e
    }
  }
}
</script>

<style lang="scss">
  .add-widget {
    &__btn {
      background: none;
      width: 100%;
      padding-top: 1.5rem;
      padding-bottom: 1.5rem;
      border: 1px dashed $color-space-light;
      border-radius: $border-radius-large;

      &:active {
        outline: none;
      }

      &:hover {
        cursor: pointer;
      }

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    &__icon {
      font-size: 2.4rem;
      padding: .8rem;
      border-radius: 50%;
      border: 1px solid $color-space;
      color: $color-space;
      margin-bottom: 1rem;
    }

    &__text {
      color: $color-space;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 1.2rem;
    }

    &__modal {
      @include respond(tab-port) {
        display: flex;
        justify-content: stretch;
      }
    }

    &__modal-menu {
      @include respond(tab-port) {
        border-right: 1px #EAEAEA solid;
        width: 25%;
      }
    }

    &__modal-menu-item {
      color: $color-black;

      &:link, &:visited {
        color: $color-black;
      }

      &:hover, &--active {
        background-color: lighten($color-primary, 45);

        &:link, &:visited {
          color: lighten($color-black, 10);
        }
      }

      &--active {
        background-color: lighten($color-primary, 47);
      }
    }

    &__modal-content {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      background-color: $color-white;

      overflow-y: auto;

      @include respond(tab-port) {
        width: 75%;

        height: initial;
        position: initial;
        top: initial;
        left: initial;
        z-index: initial;
      }
    }

    &__opts {
      /*display: flex;*/
      /*flex-wrap: wrap;*/
      /*height: inherit;*/

      & > * {
        width: 100%;
        margin-top: 2rem;
      }

      @include respond(tab-port) {

        & > &-left {
          width: 100%;
        }

        & > &-right {
          width: 100%;
        }
      }
    }
  }
</style>
